import {initializeApp} from "firebase/app";
import {browserLocalPersistence, initializeAuth} from "firebase/auth";
import {getFirestore} from "@firebase/firestore";
import {waehleFirebaseConfig} from "./firebase-umgebung";

// Die Umgebung (test1 | live) kommt aus der Build-Variable
// REACT_APP_FIREBASE_ENV; ohne gültigen Wert bricht die App hier ab.
const firebaseConfig = waehleFirebaseConfig(process.env.REACT_APP_FIREBASE_ENV);

const app = initializeApp(firebaseConfig);
// Der Mailserver ordnet einen gemeldeten Mangel über die Projekt-ID zu.
const projectId = firebaseConfig.projectId;
const db = getFirestore(app);
// Lokale Persistenz, damit die Firebase-Identität aus dem Identitätstausch
// Reloads und neue Tabs übersteht.
const auth = initializeAuth(app, {persistence: browserLocalPersistence});

export {db, auth, projectId};
